import {
  SET_ROOMID,
  GET_ROOMDATA,
} from './actions';

const initState = {};

const room = (state = initState, action) => {
  switch (action.type) {
  case SET_ROOMID:
    return {
      ...state,
      ...action.id,
    };
  case GET_ROOMDATA:
    return {
      ...state,
      data: [...action.data],
    };
  default:
    return state;
  }
};

export default room;



// WEBPACK FOOTER //
// ./src/redux/room/reducer.js